import React, { useState, useEffect } from 'react';
import { db } from '../firebase';

import {
  collection,
  addDoc,
  query,
  where,
  getDocs
} from 'firebase/firestore';

import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';

import {
  FaEye,
  FaEyeSlash,
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaGift,
  FaGlobe,
  FaShieldAlt,
  FaArrowLeft,
  FaCheckCircle,
  FaHeadset
} from 'react-icons/fa';

import './Register.css';


// =========================================================
// TRANSLATIONS
// =========================================================

const translations = {

  en: {

    title: 'Create Account',

    subtitle:
      'Join our digital football trading platform',

    fullName:
      'Full Name',

    fullNamePlaceholder:
      'Enter your full name',

    username:
      'Username',

    usernamePlaceholder:
      'Mix letters and numbers',

    email:
      'Email',

    emailPlaceholder:
      'Enter email or leave blank',

    password:
      'Password',

    passwordPlaceholder:
      'Create password',

    confirmPassword:
      'Confirm Password',

    confirmPasswordPlaceholder:
      'Confirm your password',

    phoneNumber:
      'Phone Number',

    referralCode:
      'Referral Code (optional)',

    referralPlaceholder:
      'Enter referral code',

    language:
      'Language',

    register:
      'CREATE ACCOUNT',

    processing:
      'CREATING ACCOUNT...',

    alreadyHaveAccount:
      'Already have an account?',

    loginHere:
      'Login here',

    back:
      'Back to Login',

    secure:
      'SECURE REGISTRATION',

    show:
      'Show password',

    hide:
      'Hide password',

    success:
      'Registration successful!',

    usernameNumber:
      'Username must contain at least one number.',

    passwordSame:
      'Password and username cannot be the same.',

    passwordLength:
      'Password must be between 6 - 12 characters.',

    passwordMix:
      'Password must contain letters and numbers.',

    passwordMatch:
      'Passwords do not match.',

    phoneInvalid:
      'Phone number is not valid.',

    referralInvalid:
      'Referral code is not valid.',

    usernameUsed:
      'Username is already in use.',

    fullNameRequired:
      'Full name is required.',

    genericError:
      'Something went wrong. Please try again.',

    selectCountry:
      'Select country',

    needHelp:
      'NEED HELP?',

    contactUs:
      'Contact Us',

    customerCareText:
      'Our Customer Care team is ready to help.',

    contact:
      'Contact'

  },


  sw: {

    title:
      'Fungua Akaunti',

    subtitle:
      'Jiunge na mfumo wetu wa digital trading',

    fullName:
      'Majina Matatu',

    fullNamePlaceholder:
      'Ingiza majina yako',

    username:
      'Username',

    usernamePlaceholder:
      'Changanya herufi na namba',

    email:
      'Email',

    emailPlaceholder:
      'Ingiza email au acha wazi',

    password:
      'Nenosiri',

    passwordPlaceholder:
      'Tengeneza nenosiri',

    confirmPassword:
      'Thibitisha Nenosiri',

    confirmPasswordPlaceholder:
      'Rudia nenosiri',

    phoneNumber:
      'Namba ya Simu',

    referralCode:
      'Referral Code (optional)',

    referralPlaceholder:
      'Ingiza referral code',

    language:
      'Lugha',

    register:
      'JISAJILI',

    processing:
      'INAFUNGUA AKAUNTI...',

    alreadyHaveAccount:
      'Tayari una akaunti?',

    loginHere:
      'Ingia hapa',

    back:
      'Rudi Login',

    secure:
      'USAJILI SALAMA',

    show:
      'Onyesha password',

    hide:
      'Ficha password',

    success:
      'Umefanikiwa kujisajili!',

    usernameNumber:
      'Username lazima iwe na angalau namba moja.',

    passwordSame:
      'Password na Username zifanani.',

    passwordLength:
      'Password lazima iwe kati ya 6 - 12 characters.',

    passwordMix:
      'Password lazima iwe na herufi na namba.',

    passwordMatch:
      'Passwords hazifanani.',

    phoneInvalid:
      'Namba ya simu sio sahihi.',

    referralInvalid:
      'Referral code sio sahihi.',

    usernameUsed:
      'Username tayari inatumika.',

    fullNameRequired:
      'Majina yanahitajika.',

    genericError:
      'Hitilafu imetokea. Jaribu tena.',

    selectCountry:
      'Chagua nchi',

    needHelp:
      'UNAHITAJI MSAADA?',

    contactUs:
      'Wasiliana nasi',

    customerCareText:
      'Customer Care iko tayari kukusaidia.',

    contact:
      'Wasiliana'

  },

  // FRENCH
  fr: {
    title: "Créer un compte",
    subtitle: "Rejoignez notre plateforme de trading numérique",
    fullName: "Nom complet",
    fullNamePlaceholder: "Saisissez votre nom complet",
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Mélangez lettres et chiffres",
    email: "E-mail",
    emailPlaceholder: "Saisissez votre e-mail ou laissez vide",
    password: "Mot de passe",
    passwordPlaceholder: "Créez un mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Confirmez votre mot de passe",
    phoneNumber: "Numéro de téléphone",
    referralCode: "Code de parrainage (facultatif)",
    referralPlaceholder: "Saisissez le code de parrainage",
    language: "Langue",
    register: "CRÉER UN COMPTE",
    processing: "CRÉATION DU COMPTE...",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    loginHere: "Connectez-vous ici",
    back: "Retour à la connexion",
    secure: "INSCRIPTION SÉCURISÉE",
    show: "Afficher le mot de passe",
    hide: "Masquer le mot de passe",
    success: "Inscription réussie !",
    usernameNumber: "Le nom d'utilisateur doit contenir au moins un chiffre.",
    passwordSame: "Le mot de passe ne peut pas être identique au nom d'utilisateur.",
    passwordLength: "Le mot de passe doit contenir entre 6 et 12 caractères.",
    passwordMix: "Le mot de passe doit contenir des lettres et des chiffres.",
    passwordMatch: "Les mots de passe ne correspondent pas.",
    phoneInvalid: "Le numéro de téléphone est invalide.",
    referralInvalid: "Le code de parrainage est invalide.",
    usernameUsed: "Ce nom d'utilisateur est déjà utilisé.",
    fullNameRequired: "Le nom complet est obligatoire.",
    genericError: "Une erreur s'est produite. Veuillez réessayer.",
    selectCountry: "Choisir un pays",
    needHelp: "BESOIN D'AIDE ?",
    contactUs: "Contactez-nous",
    customerCareText: "Notre service client est prêt à vous aider.",
    contact: "Contacter"
  },



// PORTUGUESE
pt: {
  title: "Criar conta",
  subtitle: "Junte-se à nossa plataforma de negociação digital",
  fullName: "Nome completo",
  fullNamePlaceholder: "Digite seu nome completo",
  username: "Nome de usuário",
  usernamePlaceholder: "Misture letras e números",
  email: "E-mail",
  emailPlaceholder: "Digite seu e-mail ou deixe em branco",
  password: "Senha",
  passwordPlaceholder: "Crie uma senha",
  confirmPassword: "Confirmar senha",
  confirmPasswordPlaceholder: "Confirme sua senha",
  phoneNumber: "Número de telefone",
  referralCode: "Código de indicação (opcional)",
  referralPlaceholder: "Digite o código de indicação",
  language: "Idioma",
  register: "CRIAR CONTA",
  processing: "CRIANDO CONTA...",
  alreadyHaveAccount: "Já tem uma conta?",
  loginHere: "Entre aqui",
  back: "Voltar para o login",
  secure: "REGISTRO SEGURO",
  show: "Mostrar senha",
  hide: "Ocultar senha",
  success: "Cadastro realizado com sucesso!",
  usernameNumber: "O nome de usuário deve conter pelo menos um número.",
  passwordSame: "A senha não pode ser igual ao nome de usuário.",
  passwordLength: "A senha deve ter entre 6 e 12 caracteres.",
  passwordMix: "A senha deve conter letras e números.",
  passwordMatch: "As senhas não coincidem.",
  phoneInvalid: "O número de telefone é inválido.",
  referralInvalid: "O código de indicação é inválido.",
  usernameUsed: "Este nome de usuário já está em uso.",
  fullNameRequired: "O nome completo é obrigatório.",
  genericError: "Ocorreu um erro. Tente novamente.",
  selectCountry: "Selecionar país",
  needHelp: "PRECISA DE AJUDA?",
  contactUs: "Entre em contato",
  customerCareText: "Nossa equipe de atendimento está pronta para ajudar.",
  contact: "Contato"
},


es: {
  title: "Crear una cuenta",
  subtitle: "Únete a nuestra plataforma de trading digital",
  fullName: "Nombre completo",
  fullNamePlaceholder: "Introduce tu nombre completo",
  username: "Nombre de usuario",
  usernamePlaceholder: "Combina letras y números",
  email: "Correo electrónico",
  emailPlaceholder: "Introduce tu correo o déjalo vacío",
  password: "Contraseña",
  passwordPlaceholder: "Crea una contraseña",
  confirmPassword: "Confirmar contraseña",
  confirmPasswordPlaceholder: "Confirma tu contraseña",
  phoneNumber: "Número de teléfono",
  referralCode: "Código de referido (opcional)",
  referralPlaceholder: "Introduce el código de referido",
  language: "Idioma",
  register: "CREAR CUENTA",
  processing: "CREANDO CUENTA...",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  loginHere: "Inicia sesión aquí",
  back: "Volver al inicio de sesión",
  secure: "REGISTRO SEGURO",
  show: "Mostrar contraseña",
  hide: "Ocultar contraseña",
  success: "¡Registro exitoso!",
  usernameNumber: "El nombre de usuario debe contener al menos un número.",
  passwordSame: "La contraseña no puede ser igual al nombre de usuario.",
  passwordLength: "La contraseña debe tener entre 6 y 12 caracteres.",
  passwordMix: "La contraseña debe contener letras y números.",
  passwordMatch: "Las contraseñas no coinciden.",
  phoneInvalid: "El número de teléfono no es válido.",
  referralInvalid: "El código de referido no es válido.",
  usernameUsed: "Este nombre de usuario ya está en uso.",
  fullNameRequired: "El nombre completo es obligatorio.",
  genericError: "Ocurrió un error. Inténtalo de nuevo.",
  selectCountry: "Seleccionar país",
  needHelp: "¿NECESITAS AYUDA?",
  contactUs: "Contáctanos",
  customerCareText: "Nuestro equipo de atención al cliente está listo para ayudarte.",
  contact: "Contacto"
},

ar: {
  title: "إنشاء حساب",
  subtitle: "انضم إلى منصة التداول الرقمية الخاصة بنا",
  fullName: "الاسم الكامل",
  fullNamePlaceholder: "أدخل اسمك الكامل",
  username: "اسم المستخدم",
  usernamePlaceholder: "استخدم مزيجًا من الحروف والأرقام",
  email: "البريد الإلكتروني",
  emailPlaceholder: "أدخل بريدك الإلكتروني أو اتركه فارغًا",
  password: "كلمة المرور",
  passwordPlaceholder: "أنشئ كلمة مرور",
  confirmPassword: "تأكيد كلمة المرور",
  confirmPasswordPlaceholder: "أكد كلمة المرور",
  phoneNumber: "رقم الهاتف",
  referralCode: "رمز الإحالة (اختياري)",
  referralPlaceholder: "أدخل رمز الإحالة",
  language: "اللغة",
  register: "إنشاء حساب",
  processing: "جارٍ إنشاء الحساب...",
  alreadyHaveAccount: "هل لديك حساب بالفعل؟",
  loginHere: "سجّل الدخول هنا",
  back: "العودة إلى تسجيل الدخول",
  secure: "تسجيل آمن",
  show: "إظهار كلمة المرور",
  hide: "إخفاء كلمة المرور",
  success: "تم التسجيل بنجاح!",
  usernameNumber: "يجب أن يحتوي اسم المستخدم على رقم واحد على الأقل.",
  passwordSame: "لا يمكن أن تكون كلمة المرور مطابقة لاسم المستخدم.",
  passwordLength: "يجب أن تتراوح كلمة المرور بين 6 و12 حرفًا.",
  passwordMix: "يجب أن تحتوي كلمة المرور على حروف وأرقام.",
  passwordMatch: "كلمتا المرور غير متطابقتين.",
  phoneInvalid: "رقم الهاتف غير صالح.",
  referralInvalid: "رمز الإحالة غير صالح.",
  usernameUsed: "اسم المستخدم مستخدم بالفعل.",
  fullNameRequired: "الاسم الكامل مطلوب.",
  genericError: "حدث خطأ. حاول مرة أخرى.",
  selectCountry: "اختر الدولة",
  needHelp: "هل تحتاج إلى مساعدة؟",
  contactUs: "اتصل بنا",
  customerCareText: "فريق خدمة العملاء لدينا مستعد لمساعدتك.",
  contact: "اتصال"
},

zh: {
  title: "创建账户",
  subtitle: "加入我们的数字交易平台",
  fullName: "全名",
  fullNamePlaceholder: "请输入您的全名",
  username: "用户名",
  usernamePlaceholder: "使用字母和数字的组合",
  email: "电子邮箱",
  emailPlaceholder: "请输入邮箱或留空",
  password: "密码",
  passwordPlaceholder: "创建密码",
  confirmPassword: "确认密码",
  confirmPasswordPlaceholder: "请确认您的密码",
  phoneNumber: "电话号码",
  referralCode: "推荐码（可选）",
  referralPlaceholder: "请输入推荐码",
  language: "语言",
  register: "创建账户",
  processing: "正在创建账户...",
  alreadyHaveAccount: "已经有账户？",
  loginHere: "在此登录",
  back: "返回登录",
  secure: "安全注册",
  show: "显示密码",
  hide: "隐藏密码",
  success: "注册成功！",
  usernameNumber: "用户名必须至少包含一个数字。",
  passwordSame: "密码不能与用户名相同。",
  passwordLength: "密码长度必须为6到12个字符。",
  passwordMix: "密码必须包含字母和数字。",
  passwordMatch: "两次输入的密码不一致。",
  phoneInvalid: "电话号码无效。",
  referralInvalid: "推荐码无效。",
  usernameUsed: "该用户名已被使用。",
  fullNameRequired: "必须填写全名。",
  genericError: "发生错误，请重试。",
  selectCountry: "选择国家",
  needHelp: "需要帮助？",
  contactUs: "联系我们",
  customerCareText: "我们的客服团队随时准备为您提供帮助。",
  contact: "联系"
},

hi: {
  title: "खाता बनाएँ",
  subtitle: "हमारे डिजिटल ट्रेडिंग प्लेटफ़ॉर्म से जुड़ें",
  fullName: "पूरा नाम",
  fullNamePlaceholder: "अपना पूरा नाम दर्ज करें",
  username: "यूज़रनेम",
  usernamePlaceholder: "अक्षरों और अंकों का मिश्रण इस्तेमाल करें",
  email: "ईमेल",
  emailPlaceholder: "अपना ईमेल दर्ज करें या खाली छोड़ दें",
  password: "पासवर्ड",
  passwordPlaceholder: "पासवर्ड बनाएँ",
  confirmPassword: "पासवर्ड की पुष्टि करें",
  confirmPasswordPlaceholder: "अपने पासवर्ड की पुष्टि करें",
  phoneNumber: "फ़ोन नंबर",
  referralCode: "रेफ़रल कोड (वैकल्पिक)",
  referralPlaceholder: "रेफ़रल कोड दर्ज करें",
  language: "भाषा",
  register: "खाता बनाएँ",
  processing: "खाता बनाया जा रहा है...",
  alreadyHaveAccount: "क्या आपका पहले से खाता है?",
  loginHere: "यहाँ लॉग इन करें",
  back: "लॉगिन पर वापस जाएँ",
  secure: "सुरक्षित पंजीकरण",
  show: "पासवर्ड दिखाएँ",
  hide: "पासवर्ड छिपाएँ",
  success: "पंजीकरण सफल हुआ!",
  usernameNumber: "यूज़रनेम में कम से कम एक अंक होना चाहिए।",
  passwordSame: "पासवर्ड यूज़रनेम के समान नहीं हो सकता।",
  passwordLength: "पासवर्ड 6 से 12 अक्षरों का होना चाहिए।",
  passwordMix: "पासवर्ड में अक्षर और अंक होने चाहिए।",
  passwordMatch: "पासवर्ड मेल नहीं खाते।",
  phoneInvalid: "फ़ोन नंबर मान्य नहीं है।",
  referralInvalid: "रेफ़रल कोड मान्य नहीं है।",
  usernameUsed: "यह यूज़रनेम पहले से उपयोग में है।",
  fullNameRequired: "पूरा नाम आवश्यक है।",
  genericError: "एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
  selectCountry: "देश चुनें",
  needHelp: "मदद चाहिए?",
  contactUs: "हमसे संपर्क करें",
  customerCareText: "हमारी ग्राहक सहायता टीम आपकी मदद के लिए तैयार है।",
  contact: "संपर्क"
},

bn: {
  title: "অ্যাকাউন্ট তৈরি করুন",
  subtitle: "আমাদের ডিজিটাল ট্রেডিং প্ল্যাটফর্মে যোগ দিন",
  fullName: "পূর্ণ নাম",
  fullNamePlaceholder: "আপনার পূর্ণ নাম লিখুন",
  username: "ব্যবহারকারীর নাম",
  usernamePlaceholder: "অক্ষর ও সংখ্যার মিশ্রণ ব্যবহার করুন",
  email: "ইমেইল",
  emailPlaceholder: "আপনার ইমেইল লিখুন অথবা খালি রাখুন",
  password: "পাসওয়ার্ড",
  passwordPlaceholder: "একটি পাসওয়ার্ড তৈরি করুন",
  confirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
  confirmPasswordPlaceholder: "আপনার পাসওয়ার্ড নিশ্চিত করুন",
  phoneNumber: "ফোন নম্বর",
  referralCode: "রেফারেল কোড (ঐচ্ছিক)",
  referralPlaceholder: "রেফারেল কোড লিখুন",
  language: "ভাষা",
  register: "অ্যাকাউন্ট তৈরি করুন",
  processing: "অ্যাকাউন্ট তৈরি হচ্ছে...",
  alreadyHaveAccount: "আপনার কি ইতিমধ্যে অ্যাকাউন্ট আছে?",
  loginHere: "এখানে লগইন করুন",
  back: "লগইনে ফিরে যান",
  secure: "নিরাপদ নিবন্ধন",
  show: "পাসওয়ার্ড দেখান",
  hide: "পাসওয়ার্ড লুকান",
  success: "নিবন্ধন সফল হয়েছে!",
  usernameNumber: "ব্যবহারকারীর নামে অন্তত একটি সংখ্যা থাকতে হবে।",
  passwordSame: "পাসওয়ার্ড ব্যবহারকারীর নামের মতো হতে পারবে না।",
  passwordLength: "পাসওয়ার্ড ৬ থেকে ১২ অক্ষরের হতে হবে।",
  passwordMix: "পাসওয়ার্ডে অক্ষর ও সংখ্যা থাকতে হবে।",
  passwordMatch: "পাসওয়ার্ড দুটি মেলেনি।",
  phoneInvalid: "ফোন নম্বরটি সঠিক নয়।",
  referralInvalid: "রেফারেল কোডটি সঠিক নয়।",
  usernameUsed: "এই ব্যবহারকারীর নামটি ইতিমধ্যে ব্যবহৃত হচ্ছে।",
  fullNameRequired: "পূর্ণ নাম আবশ্যক।",
  genericError: "একটি ত্রুটি হয়েছে। আবার চেষ্টা করুন।",
  selectCountry: "দেশ নির্বাচন করুন",
  needHelp: "সাহায্য প্রয়োজন?",
  contactUs: "আমাদের সাথে যোগাযোগ করুন",
  customerCareText: "আমাদের গ্রাহক সহায়তা দল আপনাকে সাহায্য করতে প্রস্তুত।",
  contact: "যোগাযোগ"
},


ru: {
  title: "Создать аккаунт",
  subtitle: "Присоединяйтесь к нашей цифровой торговой платформе",
  fullName: "Полное имя",
  fullNamePlaceholder: "Введите своё полное имя",
  username: "Имя пользователя",
  usernamePlaceholder: "Используйте буквы и цифры",
  email: "Электронная почта",
  emailPlaceholder: "Введите электронную почту или оставьте поле пустым",
  password: "Пароль",
  passwordPlaceholder: "Создайте пароль",
  confirmPassword: "Подтвердите пароль",
  confirmPasswordPlaceholder: "Повторите пароль",
  phoneNumber: "Номер телефона",
  referralCode: "Реферальный код (необязательно)",
  referralPlaceholder: "Введите реферальный код",
  language: "Язык",
  register: "СОЗДАТЬ АККАУНТ",
  processing: "СОЗДАНИЕ АККАУНТА...",
  alreadyHaveAccount: "Уже есть аккаунт?",
  loginHere: "Войти здесь",
  back: "Вернуться ко входу",
  secure: "БЕЗОПАСНАЯ РЕГИСТРАЦИЯ",
  show: "Показать пароль",
  hide: "Скрыть пароль",
  success: "Регистрация прошла успешно!",
  usernameNumber: "Имя пользователя должно содержать хотя бы одну цифру.",
  passwordSame: "Пароль не может совпадать с именем пользователя.",
  passwordLength: "Пароль должен содержать от 6 до 12 символов.",
  passwordMix: "Пароль должен содержать буквы и цифры.",
  passwordMatch: "Пароли не совпадают.",
  phoneInvalid: "Неверный номер телефона.",
  referralInvalid: "Недействительный реферальный код.",
  usernameUsed: "Это имя пользователя уже занято.",
  fullNameRequired: "Необходимо указать полное имя.",
  genericError: "Произошла ошибка. Попробуйте ещё раз.",
  selectCountry: "Выберите страну",
  needHelp: "НУЖНА ПОМОЩЬ?",
  contactUs: "Свяжитесь с нами",
  customerCareText: "Наша служба поддержки готова вам помочь.",
  contact: "Контакты"
},

de: {
  title: "Konto erstellen",
  subtitle: "Werde Teil unserer digitalen Handelsplattform",
  fullName: "Vollständiger Name",
  fullNamePlaceholder: "Gib deinen vollständigen Namen ein",
  username: "Benutzername",
  usernamePlaceholder: "Kombiniere Buchstaben und Zahlen",
  email: "E-Mail",
  emailPlaceholder: "Gib deine E-Mail ein oder lass das Feld leer",
  password: "Passwort",
  passwordPlaceholder: "Erstelle ein Passwort",
  confirmPassword: "Passwort bestätigen",
  confirmPasswordPlaceholder: "Bestätige dein Passwort",
  phoneNumber: "Telefonnummer",
  referralCode: "Empfehlungscode (optional)",
  referralPlaceholder: "Gib den Empfehlungscode ein",
  language: "Sprache",
  register: "KONTO ERSTELLEN",
  processing: "KONTO WIRD ERSTELLT...",
  alreadyHaveAccount: "Hast du bereits ein Konto?",
  loginHere: "Hier anmelden",
  back: "Zurück zur Anmeldung",
  secure: "SICHERE REGISTRIERUNG",
  show: "Passwort anzeigen",
  hide: "Passwort verbergen",
  success: "Registrierung erfolgreich!",
  usernameNumber: "Der Benutzername muss mindestens eine Zahl enthalten.",
  passwordSame: "Das Passwort darf nicht mit dem Benutzernamen identisch sein.",
  passwordLength: "Das Passwort muss 6 bis 12 Zeichen lang sein.",
  passwordMix: "Das Passwort muss Buchstaben und Zahlen enthalten.",
  passwordMatch: "Die Passwörter stimmen nicht überein.",
  phoneInvalid: "Die Telefonnummer ist ungültig.",
  referralInvalid: "Der Empfehlungscode ist ungültig.",
  usernameUsed: "Dieser Benutzername wird bereits verwendet.",
  fullNameRequired: "Der vollständige Name ist erforderlich.",
  genericError: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
  selectCountry: "Land auswählen",
  needHelp: "BRAUCHST DU HILFE?",
  contactUs: "Kontaktiere uns",
  customerCareText: "Unser Kundenservice hilft dir gerne weiter.",
  contact: "Kontakt"
},

it: {
  title: "Crea un account",
  subtitle: "Unisciti alla nostra piattaforma di trading digitale",
  fullName: "Nome completo",
  fullNamePlaceholder: "Inserisci il tuo nome completo",
  username: "Nome utente",
  usernamePlaceholder: "Combina lettere e numeri",
  email: "Email",
  emailPlaceholder: "Inserisci la tua email oppure lascia vuoto",
  password: "Password",
  passwordPlaceholder: "Crea una password",
  confirmPassword: "Conferma password",
  confirmPasswordPlaceholder: "Conferma la tua password",
  phoneNumber: "Numero di telefono",
  referralCode: "Codice referral (facoltativo)",
  referralPlaceholder: "Inserisci il codice referral",
  language: "Lingua",
  register: "CREA ACCOUNT",
  processing: "CREAZIONE ACCOUNT...",
  alreadyHaveAccount: "Hai già un account?",
  loginHere: "Accedi qui",
  back: "Torna al login",
  secure: "REGISTRAZIONE SICURA",
  show: "Mostra password",
  hide: "Nascondi password",
  success: "Registrazione completata con successo!",
  usernameNumber: "Il nome utente deve contenere almeno un numero.",
  passwordSame: "La password non può essere uguale al nome utente.",
  passwordLength: "La password deve contenere da 6 a 12 caratteri.",
  passwordMix: "La password deve contenere lettere e numeri.",
  passwordMatch: "Le password non corrispondono.",
  phoneInvalid: "Il numero di telefono non è valido.",
  referralInvalid: "Il codice referral non è valido.",
  usernameUsed: "Questo nome utente è già in uso.",
  fullNameRequired: "Il nome completo è obbligatorio.",
  genericError: "Si è verificato un errore. Riprova.",
  selectCountry: "Seleziona il paese",
  needHelp: "HAI BISOGNO DI AIUTO?",
  contactUs: "Contattaci",
  customerCareText: "Il nostro servizio clienti è pronto ad aiutarti.",
  contact: "Contatto"
},

nl: {
  title: "Account aanmaken",
  subtitle: "Word lid van ons digitale handelsplatform",
  fullName: "Volledige naam",
  fullNamePlaceholder: "Vul je volledige naam in",
  username: "Gebruikersnaam",
  usernamePlaceholder: "Combineer letters en cijfers",
  email: "E-mailadres",
  emailPlaceholder: "Vul je e-mailadres in of laat het leeg",
  password: "Wachtwoord",
  passwordPlaceholder: "Maak een wachtwoord aan",
  confirmPassword: "Bevestig wachtwoord",
  confirmPasswordPlaceholder: "Bevestig je wachtwoord",
  phoneNumber: "Telefoonnummer",
  referralCode: "Verwijzingscode (optioneel)",
  referralPlaceholder: "Vul de verwijzingscode in",
  language: "Taal",
  register: "ACCOUNT AANMAKEN",
  processing: "ACCOUNT WORDT AANGEMAAKT...",
  alreadyHaveAccount: "Heb je al een account?",
  loginHere: "Log hier in",
  back: "Terug naar inloggen",
  secure: "VEILIGE REGISTRATIE",
  show: "Wachtwoord tonen",
  hide: "Wachtwoord verbergen",
  success: "Registratie geslaagd!",
  usernameNumber: "De gebruikersnaam moet minstens één cijfer bevatten.",
  passwordSame: "Het wachtwoord mag niet hetzelfde zijn als de gebruikersnaam.",
  passwordLength: "Het wachtwoord moet 6 tot 12 tekens bevatten.",
  passwordMix: "Het wachtwoord moet letters en cijfers bevatten.",
  passwordMatch: "De wachtwoorden komen niet overeen.",
  phoneInvalid: "Het telefoonnummer is ongeldig.",
  referralInvalid: "De verwijzingscode is ongeldig.",
  usernameUsed: "Deze gebruikersnaam is al in gebruik.",
  fullNameRequired: "De volledige naam is verplicht.",
  genericError: "Er is een fout opgetreden. Probeer het opnieuw.",
  selectCountry: "Selecteer een land",
  needHelp: "HULP NODIG?",
  contactUs: "Neem contact met ons op",
  customerCareText: "Onze klantenservice staat klaar om je te helpen.",
  contact: "Contact"
},

tr: {
  title: "Hesap oluştur",
  subtitle: "Dijital işlem platformumuza katıl",
  fullName: "Ad soyad",
  fullNamePlaceholder: "Adınızı ve soyadınızı girin",
  username: "Kullanıcı adı",
  usernamePlaceholder: "Harf ve rakamları birlikte kullanın",
  email: "E-posta",
  emailPlaceholder: "E-postanızı girin veya boş bırakın",
  password: "Şifre",
  passwordPlaceholder: "Bir şifre oluşturun",
  confirmPassword: "Şifreyi doğrula",
  confirmPasswordPlaceholder: "Şifrenizi tekrar girin",
  phoneNumber: "Telefon numarası",
  referralCode: "Referans kodu (isteğe bağlı)",
  referralPlaceholder: "Referans kodunu girin",
  language: "Dil",
  register: "HESAP OLUŞTUR",
  processing: "HESAP OLUŞTURULUYOR...",
  alreadyHaveAccount: "Zaten bir hesabınız var mı?",
  loginHere: "Buradan giriş yapın",
  back: "Giriş sayfasına dön",
  secure: "GÜVENLİ KAYIT",
  show: "Şifreyi göster",
  hide: "Şifreyi gizle",
  success: "Kayıt başarıyla tamamlandı!",
  usernameNumber: "Kullanıcı adı en az bir rakam içermelidir.",
  passwordSame: "Şifre, kullanıcı adıyla aynı olamaz.",
  passwordLength: "Şifre 6 ila 12 karakter arasında olmalıdır.",
  passwordMix: "Şifre harf ve rakam içermelidir.",
  passwordMatch: "Şifreler eşleşmiyor.",
  phoneInvalid: "Telefon numarası geçersiz.",
  referralInvalid: "Referans kodu geçersiz.",
  usernameUsed: "Bu kullanıcı adı zaten kullanılıyor.",
  fullNameRequired: "Ad soyad alanı zorunludur.",
  genericError: "Bir hata oluştu. Lütfen tekrar deneyin.",
  selectCountry: "Ülke seçin",
  needHelp: "YARDIMA MI İHTİYACINIZ VAR?",
  contactUs: "Bize ulaşın",
  customerCareText: "Müşteri destek ekibimiz size yardımcı olmaya hazır.",
  contact: "İletişim"
},

ja: {
  title: "アカウントを作成",
  subtitle: "デジタル取引プラットフォームに参加しましょう",
  fullName: "氏名",
  fullNamePlaceholder: "氏名を入力してください",
  username: "ユーザー名",
  usernamePlaceholder: "英字と数字を組み合わせてください",
  email: "メールアドレス",
  emailPlaceholder: "メールアドレスを入力するか、空欄にしてください",
  password: "パスワード",
  passwordPlaceholder: "パスワードを作成してください",
  confirmPassword: "パスワードの確認",
  confirmPasswordPlaceholder: "パスワードを再入力してください",
  phoneNumber: "電話番号",
  referralCode: "紹介コード（任意）",
  referralPlaceholder: "紹介コードを入力してください",
  language: "言語",
  register: "アカウントを作成",
  processing: "アカウントを作成中...",
  alreadyHaveAccount: "すでにアカウントをお持ちですか？",
  loginHere: "こちらからログイン",
  back: "ログインに戻る",
  secure: "安全な登録",
  show: "パスワードを表示",
  hide: "パスワードを非表示",
  success: "登録が完了しました！",
  usernameNumber: "ユーザー名には数字を1つ以上含めてください。",
  passwordSame: "パスワードをユーザー名と同じにすることはできません。",
  passwordLength: "パスワードは6～12文字で入力してください。",
  passwordMix: "パスワードには英字と数字を含めてください。",
  passwordMatch: "パスワードが一致しません。",
  phoneInvalid: "電話番号が無効です。",
  referralInvalid: "紹介コードが無効です。",
  usernameUsed: "このユーザー名はすでに使用されています。",
  fullNameRequired: "氏名を入力してください。",
  genericError: "エラーが発生しました。もう一度お試しください。",
  selectCountry: "国を選択",
  needHelp: "お困りですか？",
  contactUs: "お問い合わせ",
  customerCareText: "カスタマーサポートチームがサポートいたします。",
  contact: "連絡先"
},

ko: {
  title: "계정 만들기",
  subtitle: "디지털 거래 플랫폼에 가입하세요",
  fullName: "전체 이름",
  fullNamePlaceholder: "전체 이름을 입력하세요",
  username: "사용자 이름",
  usernamePlaceholder: "영문자와 숫자를 조합하세요",
  email: "이메일",
  emailPlaceholder: "이메일을 입력하거나 비워 두세요",
  password: "비밀번호",
  passwordPlaceholder: "비밀번호를 만드세요",
  confirmPassword: "비밀번호 확인",
  confirmPasswordPlaceholder: "비밀번호를 다시 입력하세요",
  phoneNumber: "전화번호",
  referralCode: "추천 코드 (선택 사항)",
  referralPlaceholder: "추천 코드를 입력하세요",
  language: "언어",
  register: "계정 만들기",
  processing: "계정 생성 중...",
  alreadyHaveAccount: "이미 계정이 있으신가요?",
  loginHere: "여기서 로그인",
  back: "로그인으로 돌아가기",
  secure: "안전한 회원가입",
  show: "비밀번호 표시",
  hide: "비밀번호 숨기기",
  success: "회원가입이 완료되었습니다!",
  usernameNumber: "사용자 이름에는 숫자가 하나 이상 포함되어야 합니다.",
  passwordSame: "비밀번호는 사용자 이름과 같을 수 없습니다.",
  passwordLength: "비밀번호는 6~12자여야 합니다.",
  passwordMix: "비밀번호에는 영문자와 숫자가 포함되어야 합니다.",
  passwordMatch: "비밀번호가 일치하지 않습니다.",
  phoneInvalid: "유효하지 않은 전화번호입니다.",
  referralInvalid: "유효하지 않은 추천 코드입니다.",
  usernameUsed: "이미 사용 중인 사용자 이름입니다.",
  fullNameRequired: "전체 이름을 입력해야 합니다.",
  genericError: "오류가 발생했습니다. 다시 시도하세요.",
  selectCountry: "국가 선택",
  needHelp: "도움이 필요하신가요?",
  contactUs: "문의하기",
  customerCareText: "고객 지원팀이 도와드릴 준비가 되어 있습니다.",
  contact: "연락처"
},

vi: {
  title: "Tạo tài khoản",
  subtitle: "Tham gia nền tảng giao dịch kỹ thuật số của chúng tôi",
  fullName: "Họ và tên",
  fullNamePlaceholder: "Nhập họ và tên đầy đủ",
  username: "Tên người dùng",
  usernamePlaceholder: "Kết hợp chữ cái và chữ số",
  email: "Email",
  emailPlaceholder: "Nhập email hoặc để trống",
  password: "Mật khẩu",
  passwordPlaceholder: "Tạo mật khẩu",
  confirmPassword: "Xác nhận mật khẩu",
  confirmPasswordPlaceholder: "Nhập lại mật khẩu",
  phoneNumber: "Số điện thoại",
  referralCode: "Mã giới thiệu (không bắt buộc)",
  referralPlaceholder: "Nhập mã giới thiệu",
  language: "Ngôn ngữ",
  register: "TẠO TÀI KHOẢN",
  processing: "ĐANG TẠO TÀI KHOẢN...",
  alreadyHaveAccount: "Bạn đã có tài khoản?",
  loginHere: "Đăng nhập tại đây",
  back: "Quay lại đăng nhập",
  secure: "ĐĂNG KÝ AN TOÀN",
  show: "Hiện mật khẩu",
  hide: "Ẩn mật khẩu",
  success: "Đăng ký thành công!",
  usernameNumber: "Tên người dùng phải chứa ít nhất một chữ số.",
  passwordSame: "Mật khẩu không được giống tên người dùng.",
  passwordLength: "Mật khẩu phải có từ 6 đến 12 ký tự.",
  passwordMix: "Mật khẩu phải chứa chữ cái và chữ số.",
  passwordMatch: "Mật khẩu không khớp.",
  phoneInvalid: "Số điện thoại không hợp lệ.",
  referralInvalid: "Mã giới thiệu không hợp lệ.",
  usernameUsed: "Tên người dùng này đã được sử dụng.",
  fullNameRequired: "Vui lòng nhập họ và tên.",
  genericError: "Đã xảy ra lỗi. Vui lòng thử lại.",
  selectCountry: "Chọn quốc gia",
  needHelp: "BẠN CẦN TRỢ GIÚP?",
  contactUs: "Liên hệ với chúng tôi",
  customerCareText: "Đội ngũ hỗ trợ khách hàng luôn sẵn sàng giúp bạn.",
  contact: "Liên hệ"
},

th: {
  title: "สร้างบัญชี",
  subtitle: "เข้าร่วมแพลตฟอร์มการซื้อขายดิจิทัลของเรา",
  fullName: "ชื่อ-นามสกุล",
  fullNamePlaceholder: "กรอกชื่อ-นามสกุลของคุณ",
  username: "ชื่อผู้ใช้",
  usernamePlaceholder: "ใช้ตัวอักษรและตัวเลขผสมกัน",
  email: "อีเมล",
  emailPlaceholder: "กรอกอีเมลหรือเว้นว่างไว้",
  password: "รหัสผ่าน",
  passwordPlaceholder: "สร้างรหัสผ่าน",
  confirmPassword: "ยืนยันรหัสผ่าน",
  confirmPasswordPlaceholder: "กรอกรหัสผ่านอีกครั้ง",
  phoneNumber: "หมายเลขโทรศัพท์",
  referralCode: "รหัสแนะนำ (ไม่บังคับ)",
  referralPlaceholder: "กรอกรหัสแนะนำ",
  language: "ภาษา",
  register: "สร้างบัญชี",
  processing: "กำลังสร้างบัญชี...",
  alreadyHaveAccount: "มีบัญชีอยู่แล้วหรือไม่?",
  loginHere: "เข้าสู่ระบบที่นี่",
  back: "กลับไปหน้าเข้าสู่ระบบ",
  secure: "การสมัครที่ปลอดภัย",
  show: "แสดงรหัสผ่าน",
  hide: "ซ่อนรหัสผ่าน",
  success: "สมัครสมาชิกสำเร็จ!",
  usernameNumber: "ชื่อผู้ใช้ต้องมีตัวเลขอย่างน้อยหนึ่งตัว",
  passwordSame: "รหัสผ่านต้องไม่เหมือนชื่อผู้ใช้",
  passwordLength: "รหัสผ่านต้องมีความยาว 6 ถึง 12 ตัวอักษร",
  passwordMix: "รหัสผ่านต้องประกอบด้วยตัวอักษรและตัวเลข",
  passwordMatch: "รหัสผ่านไม่ตรงกัน",
  phoneInvalid: "หมายเลขโทรศัพท์ไม่ถูกต้อง",
  referralInvalid: "รหัสแนะนำไม่ถูกต้อง",
  usernameUsed: "ชื่อผู้ใช้นี้ถูกใช้งานแล้ว",
  fullNameRequired: "จำเป็นต้องกรอกชื่อ-นามสกุล",
  genericError: "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
  selectCountry: "เลือกประเทศ",
  needHelp: "ต้องการความช่วยเหลือหรือไม่?",
  contactUs: "ติดต่อเรา",
  customerCareText: "ทีมบริการลูกค้าของเราพร้อมให้ความช่วยเหลือคุณ",
  contact: "ติดต่อ"
},

id: {
  title: "Buat Akun",
  subtitle: "Bergabunglah dengan platform perdagangan digital kami",
  fullName: "Nama lengkap",
  fullNamePlaceholder: "Masukkan nama lengkap Anda",
  username: "Nama pengguna",
  usernamePlaceholder: "Gabungkan huruf dan angka",
  email: "Email",
  emailPlaceholder: "Masukkan email atau biarkan kosong",
  password: "Kata sandi",
  passwordPlaceholder: "Buat kata sandi",
  confirmPassword: "Konfirmasi kata sandi",
  confirmPasswordPlaceholder: "Masukkan kembali kata sandi",
  phoneNumber: "Nomor telepon",
  referralCode: "Kode referal (opsional)",
  referralPlaceholder: "Masukkan kode referal",
  language: "Bahasa",
  register: "BUAT AKUN",
  processing: "MEMBUAT AKUN...",
  alreadyHaveAccount: "Sudah memiliki akun?",
  loginHere: "Masuk di sini",
  back: "Kembali ke halaman masuk",
  secure: "PENDAFTARAN AMAN",
  show: "Tampilkan kata sandi",
  hide: "Sembunyikan kata sandi",
  success: "Pendaftaran berhasil!",
  usernameNumber: "Nama pengguna harus mengandung setidaknya satu angka.",
  passwordSame: "Kata sandi tidak boleh sama dengan nama pengguna.",
  passwordLength: "Kata sandi harus terdiri dari 6 hingga 12 karakter.",
  passwordMix: "Kata sandi harus mengandung huruf dan angka.",
  passwordMatch: "Kata sandi tidak cocok.",
  phoneInvalid: "Nomor telepon tidak valid.",
  referralInvalid: "Kode referal tidak valid.",
  usernameUsed: "Nama pengguna ini sudah digunakan.",
  fullNameRequired: "Nama lengkap wajib diisi.",
  genericError: "Terjadi kesalahan. Silakan coba lagi.",
  selectCountry: "Pilih negara",
  needHelp: "BUTUH BANTUAN?",
  contactUs: "Hubungi kami",
  customerCareText: "Tim layanan pelanggan kami siap membantu Anda.",
  contact: "Kontak"
},

ms: {
  title: "Cipta Akaun",
  subtitle: "Sertai platform dagangan digital kami",
  fullName: "Nama penuh",
  fullNamePlaceholder: "Masukkan nama penuh anda",
  username: "Nama pengguna",
  usernamePlaceholder: "Gabungkan huruf dan nombor",
  email: "E-mel",
  emailPlaceholder: "Masukkan e-mel atau biarkan kosong",
  password: "Kata laluan",
  passwordPlaceholder: "Cipta kata laluan",
  confirmPassword: "Sahkan kata laluan",
  confirmPasswordPlaceholder: "Sahkan kata laluan anda",
  phoneNumber: "Nombor telefon",
  referralCode: "Kod rujukan (pilihan)",
  referralPlaceholder: "Masukkan kod rujukan",
  language: "Bahasa",
  register: "CIPTA AKAUN",
  processing: "SEDANG MENCIPTA AKAUN...",
  alreadyHaveAccount: "Sudah mempunyai akaun?",
  loginHere: "Log masuk di sini",
  back: "Kembali ke log masuk",
  secure: "PENDAFTARAN SELAMAT",
  show: "Tunjukkan kata laluan",
  hide: "Sembunyikan kata laluan",
  success: "Pendaftaran berjaya!",
  usernameNumber: "Nama pengguna mesti mengandungi sekurang-kurangnya satu nombor.",
  passwordSame: "Kata laluan tidak boleh sama dengan nama pengguna.",
  passwordLength: "Kata laluan mesti mempunyai 6 hingga 12 aksara.",
  passwordMix: "Kata laluan mesti mengandungi huruf dan nombor.",
  passwordMatch: "Kata laluan tidak sepadan.",
  phoneInvalid: "Nombor telefon tidak sah.",
  referralInvalid: "Kod rujukan tidak sah.",
  usernameUsed: "Nama pengguna ini sudah digunakan.",
  fullNameRequired: "Nama penuh diperlukan.",
  genericError: "Ralat berlaku. Sila cuba lagi.",
  selectCountry: "Pilih negara",
  needHelp: "PERLUKAN BANTUAN?",
  contactUs: "Hubungi kami",
  customerCareText: "Pasukan khidmat pelanggan kami sedia membantu anda.",
  contact: "Hubungi"
},

ur: {
  title: "اکاؤنٹ بنائیں",
  subtitle: "ہمارے ڈیجیٹل ٹریڈنگ پلیٹ فارم میں شامل ہوں",
  fullName: "پورا نام",
  fullNamePlaceholder: "اپنا پورا نام درج کریں",
  username: "صارف نام",
  usernamePlaceholder: "حروف اور اعداد استعمال کریں",
  email: "ای میل",
  emailPlaceholder: "اپنا ای میل درج کریں یا خالی چھوڑ دیں",
  password: "پاس ورڈ",
  passwordPlaceholder: "پاس ورڈ بنائیں",
  confirmPassword: "پاس ورڈ کی تصدیق کریں",
  confirmPasswordPlaceholder: "اپنا پاس ورڈ دوبارہ درج کریں",
  phoneNumber: "فون نمبر",
  referralCode: "ریفرل کوڈ (اختیاری)",
  referralPlaceholder: "ریفرل کوڈ درج کریں",
  language: "زبان",
  register: "اکاؤنٹ بنائیں",
  processing: "اکاؤنٹ بنایا جا رہا ہے...",
  alreadyHaveAccount: "کیا آپ کا پہلے سے اکاؤنٹ ہے؟",
  loginHere: "یہاں لاگ ان کریں",
  back: "لاگ ان پر واپس جائیں",
  secure: "محفوظ رجسٹریشن",
  show: "پاس ورڈ دکھائیں",
  hide: "پاس ورڈ چھپائیں",
  success: "رجسٹریشن کامیاب ہو گئی!",
  usernameNumber: "صارف نام میں کم از کم ایک عدد ہونا ضروری ہے۔",
  passwordSame: "پاس ورڈ صارف نام جیسا نہیں ہو سکتا۔",
  passwordLength: "پاس ورڈ 6 سے 12 حروف پر مشتمل ہونا چاہیے۔",
  passwordMix: "پاس ورڈ میں حروف اور اعداد ہونا ضروری ہیں۔",
  passwordMatch: "پاس ورڈ ایک جیسے نہیں ہیں۔",
  phoneInvalid: "فون نمبر درست نہیں ہے۔",
  referralInvalid: "ریفرل کوڈ درست نہیں ہے۔",
  usernameUsed: "یہ صارف نام پہلے سے استعمال ہو رہا ہے۔",
  fullNameRequired: "پورا نام درج کرنا ضروری ہے۔",
  genericError: "ایک خرابی پیش آئی۔ دوبارہ کوشش کریں۔",
  selectCountry: "ملک منتخب کریں",
  needHelp: "مدد چاہیے؟",
  contactUs: "ہم سے رابطہ کریں",
  customerCareText: "ہماری کسٹمر سپورٹ ٹیم آپ کی مدد کے لیے تیار ہے۔",
  contact: "رابطہ"
},

fa: {
  title: "ایجاد حساب کاربری",
  subtitle: "به پلتفرم معاملات دیجیتال ما بپیوندید",
  fullName: "نام کامل",
  fullNamePlaceholder: "نام کامل خود را وارد کنید",
  username: "نام کاربری",
  usernamePlaceholder: "از ترکیب حروف و اعداد استفاده کنید",
  email: "ایمیل",
  emailPlaceholder: "ایمیل خود را وارد کنید یا خالی بگذارید",
  password: "گذرواژه",
  passwordPlaceholder: "یک گذرواژه ایجاد کنید",
  confirmPassword: "تأیید گذرواژه",
  confirmPasswordPlaceholder: "گذرواژه خود را دوباره وارد کنید",
  phoneNumber: "شماره تلفن",
  referralCode: "کد معرفی (اختیاری)",
  referralPlaceholder: "کد معرفی را وارد کنید",
  language: "زبان",
  register: "ایجاد حساب",
  processing: "در حال ایجاد حساب...",
  alreadyHaveAccount: "از قبل حساب دارید؟",
  loginHere: "از اینجا وارد شوید",
  back: "بازگشت به صفحه ورود",
  secure: "ثبت‌نام امن",
  show: "نمایش گذرواژه",
  hide: "پنهان کردن گذرواژه",
  success: "ثبت‌نام با موفقیت انجام شد!",
  usernameNumber: "نام کاربری باید حداقل یک عدد داشته باشد.",
  passwordSame: "گذرواژه نمی‌تواند با نام کاربری یکسان باشد.",
  passwordLength: "گذرواژه باید بین ۶ تا ۱۲ نویسه باشد.",
  passwordMix: "گذرواژه باید شامل حروف و اعداد باشد.",
  passwordMatch: "گذرواژه‌ها مطابقت ندارند.",
  phoneInvalid: "شماره تلفن معتبر نیست.",
  referralInvalid: "کد معرفی معتبر نیست.",
  usernameUsed: "این نام کاربری قبلاً استفاده شده است.",
  fullNameRequired: "وارد کردن نام کامل الزامی است.",
  genericError: "خطایی رخ داد. لطفاً دوباره تلاش کنید.",
  selectCountry: "انتخاب کشور",
  needHelp: "به کمک نیاز دارید؟",
  contactUs: "با ما تماس بگیرید",
  customerCareText: "تیم پشتیبانی مشتریان ما آماده کمک به شماست.",
  contact: "تماس"
},

ha: {
  title: "Ƙirƙiri Asusun",
  subtitle: "Kasance tare da dandalin ciniki na dijital ɗinmu",
  fullName: "Cikakken suna",
  fullNamePlaceholder: "Shigar da cikakken sunanka",
  username: "Sunan mai amfani",
  usernamePlaceholder: "Haɗa haruffa da lambobi",
  email: "Imel",
  emailPlaceholder: "Shigar da imel ɗinka ko ka bar wurin babu komai",
  password: "Kalmar sirri",
  passwordPlaceholder: "Ƙirƙiri kalmar sirri",
  confirmPassword: "Tabbatar da kalmar sirri",
  confirmPasswordPlaceholder: "Sake shigar da kalmar sirri",
  phoneNumber: "Lambar waya",
  referralCode: "Lambar gayyata (ba dole ba)",
  referralPlaceholder: "Shigar da lambar gayyata",
  language: "Harshe",
  register: "ƘIRƘIRI ASUSU",
  processing: "ANA ƘIRƘIRAR ASUSU...",
  alreadyHaveAccount: "Kana da asusu tuni?",
  loginHere: "Shiga nan",
  back: "Komawa shafin shiga",
  secure: "RAJISTARWA MAI TSARO",
  show: "Nuna kalmar sirri",
  hide: "Ɓoye kalmar sirri",
  success: "An yi rajista cikin nasara!",
  usernameNumber: "Dole ne sunan mai amfani ya ƙunshi aƙalla lamba ɗaya.",
  passwordSame: "Kalmar sirri ba za ta zama daidai da sunan mai amfani ba.",
  passwordLength: "Kalmar sirri dole ta kasance da haruffa 6 zuwa 12.",
  passwordMix: "Kalmar sirri dole ta ƙunshi haruffa da lambobi.",
  passwordMatch: "Kalmomin sirri ba su yi daidai ba.",
  phoneInvalid: "Lambar waya ba daidai ba ce.",
  referralInvalid: "Lambar gayyata ba ta aiki.",
  usernameUsed: "An riga an yi amfani da wannan sunan mai amfani.",
  fullNameRequired: "Ana buƙatar cikakken suna.",
  genericError: "An sami kuskure. Da fatan za a sake gwadawa.",
  selectCountry: "Zaɓi ƙasa",
  needHelp: "KANA BUKATAR TAIMAKO?",
  contactUs: "Tuntuɓe mu",
  customerCareText: "Ƙungiyar kula da abokan cinikinmu a shirye take ta taimaka maka.",
  contact: "Tuntuɓa"
},

yo: {
  title: "Ṣẹ̀dá Àkọọ́lẹ̀",
  subtitle: "Darapọ̀ mọ́ pèpéle ìṣòwò oní-nọ́ńbà wa",
  fullName: "Orúkọ kíkún",
  fullNamePlaceholder: "Tẹ orúkọ rẹ kíkún síbí",
  username: "Orúkọ aṣàmúlò",
  usernamePlaceholder: "Lo àpapọ̀ lẹ́tà àti nọ́ńbà",
  email: "Ímeèlì",
  emailPlaceholder: "Tẹ ímeèlì rẹ síbí tàbí fi sílẹ̀ ṣófo",
  password: "Ọ̀rọ̀ aṣínà",
  passwordPlaceholder: "Ṣẹ̀dá ọ̀rọ̀ aṣínà",
  confirmPassword: "Jẹ́rìí ọ̀rọ̀ aṣínà",
  confirmPasswordPlaceholder: "Tẹ ọ̀rọ̀ aṣínà rẹ lẹ́ẹ̀kansi",
  phoneNumber: "Nọ́ńbà fóònù",
  referralCode: "Kóòdù ìtọ́kasí (kò pọn dandan)",
  referralPlaceholder: "Tẹ kóòdù ìtọ́kasí síbí",
  language: "Èdè",
  register: "ṢẸ̀DÁ ÀKỌỌ́LẸ̀",
  processing: "A Ń ṢẸ̀DÁ ÀKỌỌ́LẸ̀...",
  alreadyHaveAccount: "Ṣé o ti ní àkọọ́lẹ̀ tẹ́lẹ̀?",
  loginHere: "Wọlé níbí",
  back: "Padà sí ojú ìwọlé",
  secure: "ÌFORÚKỌSÍLẸ̀ ÀÌLÉWU",
  show: "Fi ọ̀rọ̀ aṣínà hàn",
  hide: "Fi ọ̀rọ̀ aṣínà pamọ́",
  success: "Ìforúkọsílẹ̀ ṣàṣeyọrí!",
  usernameNumber: "Orúkọ aṣàmúlò gbọ́dọ̀ ní ó kéré tán nọ́ńbà kan.",
  passwordSame: "Ọ̀rọ̀ aṣínà kò gbọdọ̀ jẹ́ bákan náà pẹ̀lú orúkọ aṣàmúlò.",
  passwordLength: "Ọ̀rọ̀ aṣínà gbọ́dọ̀ ní lẹ́tà 6 sí 12.",
  passwordMix: "Ọ̀rọ̀ aṣínà gbọ́dọ̀ ní lẹ́tà àti nọ́ńbà.",
  passwordMatch: "Àwọn ọ̀rọ̀ aṣínà kò bá ara wọn mu.",
  phoneInvalid: "Nọ́ńbà fóònù kò tọ́.",
  referralInvalid: "Kóòdù ìtọ́kasí kò tọ́.",
  usernameUsed: "Ẹlòmíràn ti ń lo orúkọ aṣàmúlò yìí.",
  fullNameRequired: "Ó pọn dandan láti tẹ orúkọ kíkún sílẹ̀.",
  genericError: "Àṣìṣe kan ṣẹlẹ̀. Jọ̀wọ́ tún gbìyànjú.",
  selectCountry: "Yan orílẹ̀-èdè",
  needHelp: "ṢÉ O NÍ ÌRÀNLỌ́WỌ́?",
  contactUs: "Kàn sí wa",
  customerCareText: "Ẹgbẹ́ ìtọ́jú oníbàárà wa ti ṣetán láti ràn ọ́ lọ́wọ́.",
  contact: "Ìbánisọ̀rọ̀"
},

zu: {
  title: "Dala I-akhawunti",
  subtitle: "Joyina inkundla yethu yokuhweba ngedijithali",
  fullName: "Igama eligcwele",
  fullNamePlaceholder: "Faka igama lakho eligcwele",
  username: "Igama lomsebenzisi",
  usernamePlaceholder: "Hlanganisa izinhlamvu nezinombolo",
  email: "I-imeyili",
  emailPlaceholder: "Faka i-imeyili yakho noma uyeke kungenalutho",
  password: "Iphasiwedi",
  passwordPlaceholder: "Dala iphasiwedi",
  confirmPassword: "Qinisekisa iphasiwedi",
  confirmPasswordPlaceholder: "Faka iphasiwedi yakho futhi",
  phoneNumber: "Inombolo yocingo",
  referralCode: "Ikhodi yokudlulisela (ongakukhetha)",
  referralPlaceholder: "Faka ikhodi yokudlulisela",
  language: "Ulimi",
  register: "DALA I-AKHAWUNTI",
  processing: "KUDALWA I-AKHAWUNTI...",
  alreadyHaveAccount: "Usunayo yini i-akhawunti?",
  loginHere: "Ngena ngemvume lapha",
  back: "Buyela ekungeneni ngemvume",
  secure: "UKUBHALISA OKUPHEPHILE",
  show: "Bonisa iphasiwedi",
  hide: "Fihla iphasiwedi",
  success: "Ukubhalisa kuphumelele!",
  usernameNumber: "Igama lomsebenzisi kufanele libe nenombolo okungenani eyodwa.",
  passwordSame: "Iphasiwedi ayikwazi ukufana negama lomsebenzisi.",
  passwordLength: "Iphasiwedi kufanele ibe nezinhlamvu ezingu-6 kuya kwezingu-12.",
  passwordMix: "Iphasiwedi kufanele ibe nezinhlamvu nezinombolo.",
  passwordMatch: "Amaphasiwedi awafani.",
  phoneInvalid: "Inombolo yocingo ayivumelekile.",
  referralInvalid: "Ikhodi yokudlulisela ayivumelekile.",
  usernameUsed: "Leli gama lomsebenzisi selisetshenziswa.",
  fullNameRequired: "Igama eligcwele liyadingeka.",
  genericError: "Kwenzeke iphutha. Sicela uzame futhi.",
  selectCountry: "Khetha izwe",
  needHelp: "UDINGA USIZO?",
  contactUs: "Xhumana nathi",
  customerCareText: "Ithimba lethu lokusiza amakhasimende likulungele ukukusiza.",
  contact: "Oxhumana naye"
},

am: {
  title: "መለያ ይፍጠሩ",
  subtitle: "የዲጂታል ንግድ መድረካችንን ይቀላቀሉ",
  fullName: "ሙሉ ስም",
  fullNamePlaceholder: "ሙሉ ስምዎን ያስገቡ",
  username: "የተጠቃሚ ስም",
  usernamePlaceholder: "ፊደላትን እና ቁጥሮችን ያቀላቅሉ",
  email: "ኢሜይል",
  emailPlaceholder: "ኢሜይልዎን ያስገቡ ወይም ባዶ ይተዉት",
  password: "የይለፍ ቃል",
  passwordPlaceholder: "የይለፍ ቃል ይፍጠሩ",
  confirmPassword: "የይለፍ ቃሉን ያረጋግጡ",
  confirmPasswordPlaceholder: "የይለፍ ቃሉን እንደገና ያስገቡ",
  phoneNumber: "ስልክ ቁጥር",
  referralCode: "የሪፈራል ኮድ (አማራጭ)",
  referralPlaceholder: "የሪፈራል ኮዱን ያስገቡ",
  language: "ቋንቋ",
  register: "መለያ ይፍጠሩ",
  processing: "መለያ በመፍጠር ላይ...",
  alreadyHaveAccount: "አስቀድመው መለያ አለዎት?",
  loginHere: "እዚህ ይግቡ",
  back: "ወደ መግቢያ ይመለሱ",
  secure: "ደህንነቱ የተጠበቀ ምዝገባ",
  show: "የይለፍ ቃሉን አሳይ",
  hide: "የይለፍ ቃሉን ደብቅ",
  success: "ምዝገባው በተሳካ ሁኔታ ተጠናቋል!",
  usernameNumber: "የተጠቃሚ ስሙ ቢያንስ አንድ ቁጥር መያዝ አለበት።",
  passwordSame: "የይለፍ ቃሉ ከተጠቃሚ ስሙ ጋር አንድ መሆን የለበትም።",
  passwordLength: "የይለፍ ቃሉ ከ6 እስከ 12 ቁምፊዎች መሆን አለበት።",
  passwordMix: "የይለፍ ቃሉ ፊደላትን እና ቁጥሮችን መያዝ አለበት።",
  passwordMatch: "የይለፍ ቃሎቹ አይዛመዱም።",
  phoneInvalid: "የስልክ ቁጥሩ ትክክል አይደለም።",
  referralInvalid: "የሪፈራል ኮዱ ትክክል አይደለም።",
  usernameUsed: "ይህ የተጠቃሚ ስም አስቀድሞ ጥቅም ላይ ውሏል።",
  fullNameRequired: "ሙሉ ስም ማስገባት ያስፈልጋል።",
  genericError: "ስህተት ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።",
  selectCountry: "አገር ይምረጡ",
  needHelp: "እርዳታ ይፈልጋሉ?",
  contactUs: "ያግኙን",
  customerCareText: "የደንበኞች ድጋፍ ቡድናችን ሊረዳዎት ዝግጁ ነው።",
  contact: "ያግኙ"
},

so: {
  title: "Samee Akoon",
  subtitle: "Ku soo biir madalkeenna ganacsiga dhijitaalka ah",
  fullName: "Magaca oo buuxa",
  fullNamePlaceholder: "Geli magacaaga oo buuxa",
  username: "Magaca isticmaalaha",
  usernamePlaceholder: "Isku dar xarfo iyo tirooyin",
  email: "Iimayl",
  emailPlaceholder: "Geli iimaylkaaga ama bannaan ka tag",
  password: "Furaha sirta ah",
  passwordPlaceholder: "Samee furaha sirta ah",
  confirmPassword: "Xaqiiji furaha sirta ah",
  confirmPasswordPlaceholder: "Mar kale geli furaha sirta ah",
  phoneNumber: "Lambarka telefoonka",
  referralCode: "Koodhka gudbinta (ikhtiyaari)",
  referralPlaceholder: "Geli koodhka gudbinta",
  language: "Luqad",
  register: "SAMEE AKOON",
  processing: "AKOONKA WAA LA SAMAYNAYAA...",
  alreadyHaveAccount: "Akoon ma leedahay?",
  loginHere: "Halkan ka gal",
  back: "Ku noqo gelitaanka",
  secure: "DIIWAANGELIN AMMAAN AH",
  show: "Muuji furaha sirta ah",
  hide: "Qari furaha sirta ah",
  success: "Diiwaangelintu way guulaysatay!",
  usernameNumber: "Magaca isticmaaluhu waa inuu ka koobnaadaa ugu yaraan hal tiro.",
  passwordSame: "Furaha sirta ahi lama mid noqon karo magaca isticmaalaha.",
  passwordLength: "Furaha sirta ahi waa inuu ka koobnaadaa 6 ilaa 12 xaraf.",
  passwordMix: "Furaha sirta ahi waa inuu ka koobnaadaa xarfo iyo tirooyin.",
  passwordMatch: "Furayaasha sirta ahi isma waafaqaan.",
  phoneInvalid: "Lambarka telefoonku sax ma aha.",
  referralInvalid: "Koodhka gudbintu sax ma aha.",
  usernameUsed: "Magacan isticmaalaha hore ayaa loo isticmaalay.",
  fullNameRequired: "Magaca oo buuxa waa loo baahan yahay.",
  genericError: "Cilad ayaa dhacday. Fadlan mar kale isku day.",
  selectCountry: "Dooro waddan",
  needHelp: "MA U BAAHAN TAHAY CAAWIN?",
  contactUs: "Nala soo xiriir",
  customerCareText: "Kooxdayada adeegga macaamiishu waxay diyaar u tahay inay ku caawiso.",
  contact: "Xiriir"
},

rw: {
  title: "Fungura Konti",
  subtitle: "Injira ku rubuga rwacu rw'ubucuruzi bwo kuri murandasi",
  fullName: "Amazina yose",
  fullNamePlaceholder: "Andika amazina yawe yose",
  username: "Izina ukoresha",
  usernamePlaceholder: "Vanga inyuguti n'imibare",
  email: "Imeyili",
  emailPlaceholder: "Andika imeyili yawe cyangwa ubireke ubusa",
  password: "Ijambo ry'ibanga",
  passwordPlaceholder: "Shyiraho ijambo ry'ibanga",
  confirmPassword: "Emeza ijambo ry'ibanga",
  confirmPasswordPlaceholder: "Ongera wandike ijambo ry'ibanga",
  phoneNumber: "Nimero ya telefoni",
  referralCode: "Kode yo gutumira (si ngombwa)",
  referralPlaceholder: "Andika kode yo gutumira",
  language: "Ururimi",
  register: "FUNGURA KONTI",
  processing: "KONTI IRIMO GUKORWA...",
  alreadyHaveAccount: "Usanzwe ufite konti?",
  loginHere: "Injira hano",
  back: "Subira ku kwinjira",
  secure: "KWANDIKISHA MU MUTEKANO",
  show: "Erekana ijambo ry'ibanga",
  hide: "Hisha ijambo ry'ibanga",
  success: "Kwiyandikisha byagenze neza!",
  usernameNumber: "Izina ukoresha rigomba kugira nibura umubare umwe.",
  passwordSame: "Ijambo ry'ibanga ntirishobora gusa n'izina ukoresha.",
  passwordLength: "Ijambo ry'ibanga rigomba kugira inyuguti 6 kugeza kuri 12.",
  passwordMix: "Ijambo ry'ibanga rigomba kugira inyuguti n'imibare.",
  passwordMatch: "Amagambo y'ibanga ntahura.",
  phoneInvalid: "Nimero ya telefoni si yo.",
  referralInvalid: "Kode yo gutumira si yo.",
  usernameUsed: "Iri zina rikoreshwa n'undi muntu.",
  fullNameRequired: "Amazina yose arakenewe.",
  genericError: "Habaye ikosa. Ongera ugerageze.",
  selectCountry: "Hitamo igihugu",
  needHelp: "Ukeneye ubufasha?",
  contactUs: "Twandikire",
  customerCareText: "Itsinda ryacu ryita ku bakiriya ryiteguye kugufasha.",
  contact: "Aho watwandikira"
},

lg: {
  title: "Kola Akawunti",
  subtitle: "Wegatte ku mukutu gwaffe ogw'obusuubuzi obwa digito",
  fullName: "Erinnya erijjuvu",
  fullNamePlaceholder: "Wandiika erinnya lyo erijjuvu",
  username: "Erinnya ly'omukozesa",
  usernamePlaceholder: "Tabula ennukuta n'ennamba",
  email: "Emeyiro",
  emailPlaceholder: "Wandiika emeyiro yo oba oleke ekifo kino nga kyereere",
  password: "Ekigambo eky'ekyama",
  passwordPlaceholder: "Teekawo ekigambo eky'ekyama",
  confirmPassword: "Kakasa ekigambo eky'ekyama",
  confirmPasswordPlaceholder: "Ddamu okuwandiika ekigambo eky'ekyama",
  phoneNumber: "Namba ya ssimu",
  referralCode: "Koodi ey'okuyitibwa (si ya buwaze)",
  referralPlaceholder: "Wandiika koodi ey'okuyitibwa",
  language: "Olulimi",
  register: "KOLA AKAWUNTI",
  processing: "AKAWUNTI EKOLWA...",
  alreadyHaveAccount: "Olina akawunti dda?",
  loginHere: "Yingira wano",
  back: "Ddayo ku muko ogw'okuyingiriramu",
  secure: "OKWETTAAGA MU NGERI EY'OBWEKAKASA",
  show: "Laga ekigambo eky'ekyama",
  hide: "Kweka ekigambo eky'ekyama",
  success: "Okwetaba ku mukutu kuwedde bulungi!",
  usernameNumber: "Erinnya ly'omukozesa lirina okubaamu waakiri ennamba emu.",
  passwordSame: "Ekigambo eky'ekyama tekisaanidde kufaanana linnya ly'omukozesa.",
  passwordLength: "Ekigambo eky'ekyama kirina okuba n'ennukuta 6 okutuuka ku 12.",
  passwordMix: "Ekigambo eky'ekyama kirina okubaamu ennukuta n'ennamba.",
  passwordMatch: "Ebigambo eby'ekyama tebifaanaganye.",
  phoneInvalid: "Namba ya ssimu si ntuufu.",
  referralInvalid: "Koodi ey'okuyitibwa si ntuufu.",
  usernameUsed: "Erinnya lino ly'omukozesa likozesebwa dda.",
  fullNameRequired: "Erinnya erijjuvu lyetaagisa.",
  genericError: "Wabaddewo ensobi. Ddamu ogezeeko.",
  selectCountry: "Londa eggwanga",
  needHelp: "WETAAGA OBUYAMBI?",
  contactUs: "Tutukirire",
  customerCareText: "Ttiimu yaffe ey'abakola ku bakasitoma yeetegefu okukuyamba.",
  contact: "Okutukirira"
},

af: {
  title: "Skep 'n rekening",
  subtitle: "Sluit aan by ons digitale handelsplatform",
  fullName: "Volle naam",
  fullNamePlaceholder: "Voer jou volle naam in",
  username: "Gebruikersnaam",
  usernamePlaceholder: "Kombineer letters en syfers",
  email: "E-posadres",
  emailPlaceholder: "Voer jou e-posadres in of laat dit leeg",
  password: "Wagwoord",
  passwordPlaceholder: "Skep 'n wagwoord",
  confirmPassword: "Bevestig wagwoord",
  confirmPasswordPlaceholder: "Bevestig jou wagwoord",
  phoneNumber: "Telefoonnommer",
  referralCode: "Verwysingskode (opsioneel)",
  referralPlaceholder: "Voer die verwysingskode in",
  language: "Taal",
  register: "SKEP REKENING",
  processing: "REKENING WORD GESKEP...",
  alreadyHaveAccount: "Het jy reeds 'n rekening?",
  loginHere: "Meld hier aan",
  back: "Terug na aanmelding",
  secure: "VEILIGE REGISTRASIE",
  show: "Wys wagwoord",
  hide: "Versteek wagwoord",
  success: "Registrasie was suksesvol!",
  usernameNumber: "Die gebruikersnaam moet minstens een syfer bevat.",
  passwordSame: "Die wagwoord mag nie dieselfde as die gebruikersnaam wees nie.",
  passwordLength: "Die wagwoord moet 6 tot 12 karakters lank wees.",
  passwordMix: "Die wagwoord moet letters en syfers bevat.",
  passwordMatch: "Die wagwoorde stem nie ooreen nie.",
  phoneInvalid: "Die telefoonnommer is ongeldig.",
  referralInvalid: "Die verwysingskode is ongeldig.",
  usernameUsed: "Hierdie gebruikersnaam is reeds in gebruik.",
  fullNameRequired: "Die volle naam is verpligtend.",
  genericError: "Daar het 'n fout voorgekom. Probeer asseblief weer.",
  selectCountry: "Kies land",
  needHelp: "HET JY HULP NODIG?",
  contactUs: "Kontak ons",
  customerCareText: "Ons kliëntediensspan is gereed om jou te help.",
  contact: "Kontak"
},

"pt-AO": {
  title: "Criar conta",
  subtitle: "Junte-se à nossa plataforma de negociação digital",
  fullName: "Nome completo",
  fullNamePlaceholder: "Introduza o seu nome completo",
  username: "Nome de utilizador",
  usernamePlaceholder: "Utilize letras e números",
  email: "E-mail",
  emailPlaceholder: "Introduza o seu e-mail ou deixe em branco",
  password: "Palavra-passe",
  passwordPlaceholder: "Crie uma palavra-passe",
  confirmPassword: "Confirmar palavra-passe",
  confirmPasswordPlaceholder: "Confirme a sua palavra-passe",
  phoneNumber: "Número de telefone",
  referralCode: "Código de referência (opcional)",
  referralPlaceholder: "Introduza o código de referência",
  language: "Idioma",
  register: "CRIAR CONTA",
  processing: "A CRIAR CONTA...",
  alreadyHaveAccount: "Já tem uma conta?",
  loginHere: "Inicie sessão aqui",
  back: "Voltar ao início de sessão",
  secure: "REGISTO SEGURO",
  show: "Mostrar palavra-passe",
  hide: "Ocultar palavra-passe",
  success: "Registo efetuado com sucesso!",
  usernameNumber: "O nome de utilizador deve conter pelo menos um número.",
  passwordSame: "A palavra-passe não pode ser igual ao nome de utilizador.",
  passwordLength: "A palavra-passe deve ter entre 6 e 12 caracteres.",
  passwordMix: "A palavra-passe deve conter letras e números.",
  passwordMatch: "As palavras-passe não coincidem.",
  phoneInvalid: "O número de telefone é inválido.",
  referralInvalid: "O código de referência é inválido.",
  usernameUsed: "Este nome de utilizador já está em uso.",
  fullNameRequired: "O nome completo é obrigatório.",
  genericError: "Ocorreu um erro. Tente novamente.",
  selectCountry: "Selecionar país",
  needHelp: "PRECISA DE AJUDA?",
  contactUs: "Contacte-nos",
  customerCareText: "A nossa equipa de apoio ao cliente está pronta para ajudar.",
  contact: "Contacto"
}




};


// =========================================================
// COUNTRY PREFIXES
// =========================================================

const prefixes = {

  Tanzania: '+255',
  Kenya: '+254',
  Uganda: '+256',
  Rwanda: '+250',
  Burundi: '+257',
  Zambia: '+260',
  Malawi: '+265',
  Mozambique: '+258',
  Nigeria: '+234',
  Ghana: '+233',
  SouthAfrica: '+27',
  Zimbabwe: '+263',
  Botswana: '+267',
  Namibia: '+264',
  Ethiopia: '+251',
  Somalia: '+252',
  Sudan: '+249',
  SouthSudan: '+211',
  Egypt: '+20',
  Morocco: '+212',
  Algeria: '+213',
  Tunisia: '+216',
  Libya: '+218',
  Senegal: '+221',
  IvoryCoast: '+225',
  Cameroon: '+237',
  DR_Congo: '+243',
  Congo: '+242',
  SierraLeone: '+232',
  Liberia: '+231',
  Benin: '+229',
  Togo: '+228',
  BurkinaFaso: '+226',
  Mali: '+223',
  Niger: '+227',
  Guinea: '+224',
  Gambia: '+220',

  UnitedKingdom: '+44',
  Germany: '+49',
  France: '+33',
  Italy: '+39',
  Spain: '+34',
  Netherlands: '+31',
  Belgium: '+32',
  Switzerland: '+41',
  Sweden: '+46',
  Norway: '+47',
  Denmark: '+45',
  Finland: '+358',
  Ireland: '+353',
  Portugal: '+351',
  Poland: '+48',
  Austria: '+43',
  Greece: '+30',

  UnitedStates: '+1',
  Canada: '+1',
  Mexico: '+52',
  Brazil: '+55',
  Argentina: '+54',
  Chile: '+56',
  Colombia: '+57',
  Peru: '+51',
  Venezuela: '+58',

  India: '+91',
  Pakistan: '+92',
  Bangladesh: '+880',
  SriLanka: '+94',
  Nepal: '+977',
  China: '+86',
  Japan: '+81',
  SouthKorea: '+82',
  Indonesia: '+62',
  Malaysia: '+60',
  Singapore: '+65',
  Thailand: '+66',
  Philippines: '+63',
  Vietnam: '+84',

  SaudiArabia: '+966',
  UnitedArabEmirates: '+971',
  Qatar: '+974',
  Kuwait: '+965',
  Oman: '+968',
  Israel: '+972',
  Turkey: '+90',
  Iran: '+98',
  Iraq: '+964',

  Australia: '+61',
  NewZealand: '+64',

  Other: ''

};


// =========================================================
// REGISTER COMPONENT
// =========================================================

const Register = () => {




  const LANGUAGES = [
    { code: "en", nativeName: "🇬🇧 English" },
    { code: "sw", nativeName: "🇹🇿 Kiswahili" },
    { code: "pt", nativeName: "🇵🇹 Português" },
    { code: "fr", nativeName: "🇫🇷 Français" },
    { code: "es", nativeName: "🇪🇸 Español" },
    { code: "pt-AO", nativeName: "🇦🇴 Português (Angola)" },


    { code: "ar", nativeName: "🇸🇦 العربية" },
    { code: "zh", nativeName: "🇨🇳 中文" },
    { code: "hi", nativeName: "🇮🇳 हिन्दी" },
    { code: "bn", nativeName: "🇧🇩 বাংলা" },
    { code: "ru", nativeName: "🇷🇺 Русский" },
    { code: "de", nativeName: "🇩🇪 Deutsch" },
    { code: "it", nativeName: "🇮🇹 Italiano" },
    { code: "nl", nativeName: "🇳🇱 Nederlands" },
    { code: "tr", nativeName: "🇹🇷 Türkçe" },
    { code: "ja", nativeName: "🇯🇵 日本語" },
    { code: "ko", nativeName: "🇰🇷 한국어" },
    { code: "vi", nativeName: "🇻🇳 Tiếng Việt" },
    { code: "th", nativeName: "🇹🇭 ไทย" },
    { code: "id", nativeName: "🇮🇩 Bahasa Indonesia" },
    { code: "ms", nativeName: "🇲🇾 Bahasa Melayu" },
    { code: "ur", nativeName: "🇵🇰 اردو" },
    { code: "fa", nativeName: "🇮🇷 فارسی" },
    { code: "ha", nativeName: "Hausa" },
    { code: "yo", nativeName: "Yorùbá" },
    { code: "zu", nativeName: "🇿🇦 isiZulu" },
    { code: "am", nativeName: "🇪🇹 አማርኛ" },
    { code: "so", nativeName: "🇸🇴 Soomaali" },
    { code: "rw", nativeName: "🇷🇼 Ikinyarwanda" },
    { code: "lg", nativeName: "🇺🇬 Luganda" },
    { code: "af", nativeName: "🇿🇦 Afrikaans" }
  ];


  const navigate = useNavigate();

  const location = useLocation();


  // =======================================================
  // FORM
  // =======================================================

  const [form, setForm] = useState({

    fullName: '',

    username: '',

    email: '',

    password: '',

    confirmPassword: '',

    phoneNumber: '',

    referralInput: '',

    language: 'en'

  });


  const [country, setCountry] =
    useState('Tanzania');


  const [prefix, setPrefix] =
    useState('+255');


  const [success, setSuccess] =
    useState('');


  const [error, setError] =
    useState('');


  const [isLoading, setIsLoading] =
    useState(false);


  const [showPassword, setShowPassword] =
    useState(false);


  const [showConfirmPassword, setShowConfirmPassword] =
    useState(false);


  // =======================================================
  // TRANSLATION
  // =======================================================

  const t =
    translations[form.language] ||
    translations.en;


  // =======================================================
  // BACKGROUND SLIDESHOW
  // =======================================================

  const images = [
    '/bg1.jpg',
    '/bg2.jpg',
    '/bg3.jpg'
  ];


  const [currentImage, setCurrentImage] =
    useState(0);


  useEffect(() => {

    const interval =
      setInterval(() => {

        setCurrentImage(
          prev =>
            (prev + 1) %
            images.length
        );

      }, 4000);


    return () =>
      clearInterval(interval);

  }, []);


  // =======================================================
  // AUTO REFERRAL FROM URL
  // =======================================================

  useEffect(() => {

    const params =
      new URLSearchParams(
        location.search
      );


    const ref =
      params.get('ref');


    if (ref) {

      setForm(prev => ({

        ...prev,

        referralInput:
          ref

      }));

    }

  }, [location.search]);


  // =======================================================
  // COUNTRY CHANGE
  // =======================================================

  const handleCountryChange =
    (e) => {

      const selected =
        e.target.value;


      setCountry(
        selected
      );


      setPrefix(
        prefixes[selected] || ''
      );

      setError('');

      setSuccess('');

    };


  // =======================================================
  // FORM CHANGE
  // =======================================================

  const handleChange =
    (e) => {

      const {
        name,
        value
      } = e.target;


      const cleaned =
        [
          'username',
          'password',
          'confirmPassword'
        ].includes(name)

          ? value.replace(
              /\s/g,
              ''
            )

          : value;


      setForm(prev => ({

        ...prev,

        [name]:
          cleaned

      }));


      setError('');

      setSuccess('');

    };


  // =======================================================
  // PHONE CHANGE
  // =======================================================

  const handlePhoneChange =
    (e) => {

      const value =
        e.target.value.replace(
          /\D/g,
          ''
        );


      setForm(prev => ({

        ...prev,

        phoneNumber:
          value

      }));


      setError('');

      setSuccess('');

    };


  // =======================================================
  // HELPERS
  // =======================================================

  const usernameHasNumber =
    uname =>
      /\d/.test(uname);


  const sanitizePhone =
    phone =>
      phone.replace(
        /\D/g,
        ''
      );


  const generateReferralCode =
    () =>
      `${Math.floor(
        1000000 +
        Math.random() *
        9000000
      )}`;


  // =======================================================
  // STOP
  // =======================================================

  const stop =
    (msg) => {

      setError(msg);

      setIsLoading(false);

    };


  // =======================================================
  // REGISTER
  // =======================================================

  const handleRegister =
    async (e) => {

      e.preventDefault();


      if (isLoading) {
        return;
      }


      setIsLoading(true);

      setError('');

      setSuccess('');


      const {

        fullName,

        username,

        email,

        password,

        confirmPassword,

        phoneNumber,

        referralInput

      } = form;


      // ===================================================
      // FULL NAME
      // ===================================================

      if (!fullName.trim()) {

        return stop(
          t.fullNameRequired
        );

      }


      // ===================================================
      // USERNAME
      // ===================================================

      if (
        username.length < 6 ||
        username.length > 16
      ) {

        return stop(
          'Username must be between 6 - 16 characters.'
        );

      }


      if (
        !usernameHasNumber(
          username
        )
      ) {

        return stop(
          t.usernameNumber
        );

      }


      // ===================================================
      // EMAIL
      //
      // OPTIONAL.
      //
      // NO DUPLICATE EMAIL CHECK.
      // ===================================================

      const cleanEmail =
        email.trim().toLowerCase();


      // ===================================================
      // PASSWORD
      // ===================================================

      if (
        password.length < 6 ||
        password.length > 12
      ) {

        return stop(
          t.passwordLength
        );

      }


      if (
        password.toLowerCase() ===
        username.toLowerCase()
      ) {

        return stop(
          t.passwordSame
        );

      }


      if (
        !/[A-Za-z]/.test(
          password
        ) ||
        !/\d/.test(
          password
        )
      ) {

        return stop(
          t.passwordMix
        );

      }


      if (
        password !==
        confirmPassword
      ) {

        return stop(
          t.passwordMatch
        );

      }


      // ===================================================
      // PHONE
      // ===================================================

      const cleanPhone =
        sanitizePhone(
          phoneNumber
        );


      if (
        cleanPhone.length < 9
      ) {

        return stop(
          t.phoneInvalid
        );

      }


      // ===================================================
      // FIRESTORE
      // ===================================================

      try {

        // =================================================
        // REFERRAL
        // =================================================

        let referralBy =
          '';


        const cleanReferral =
          referralInput.trim();


        if (
          cleanReferral !== ''
        ) {

          const refSnap =
            await getDocs(
              query(
                collection(
                  db,
                  'users'
                ),

                where(
                  'referralCode',
                  '==',
                  cleanReferral
                )
              )
            );


          if (
            refSnap.empty
          ) {

            return stop(
              t.referralInvalid
            );

          }


          refSnap.forEach(
            doc => {

              referralBy =
                doc.data()
                  .username ||
                '';

            }
          );

        }


        // =================================================
        // CHECK USERNAME
        // =================================================

        const userSnap =
          await getDocs(
            query(
              collection(
                db,
                'users'
              ),

              where(
                'username',
                '==',
                username
              )
            )
          );


        if (
          !userSnap.empty
        ) {

          return stop(
            t.usernameUsed
          );

        }


        // =================================================
        // GENERATE REFERRAL CODE
        // =================================================

        const newReferralCode =
          generateReferralCode();


        const referralLink =
          `https://bfctrade.cc/register?ref=${newReferralCode}`;


        // =================================================
        // CREATE USER
        // =================================================

        await addDoc(
          collection(
            db,
            'users'
          ),

          {

            fullName:
              fullName.trim(),

            username:
              username.trim(),

            email:
              cleanEmail,

            password,

            phoneNumber:
              prefix +
              cleanPhone,

            country,

            language:
              form.language,

            referralCode:
              newReferralCode,

            referralLink,

            whoReferredWho:
              cleanReferral ||
              '',

            referralBy,

            role:
              'user',

            createdAt:
              new Date(),

            isBlocked:
              false,

            blockExpiresAt:
              null,

            depositedAmountOnJoinDay:
              0,

            tshBalance:
              0,

            usdtBalance:
              0

          }
        );


        // =================================================
        // SAVE USERNAME
        // =================================================

        localStorage.setItem(
          'username',
          username
        );


        // =================================================
        // SUCCESS
        // =================================================

        setSuccess(
          t.success
        );


        setIsLoading(false);


        // =================================================
        // REDIRECT TO LOGIN
        // =================================================

        setTimeout(() => {

          navigate(
            '/login',
            {
              replace: true
            }
          );

        }, 1500);


      } catch (err) {

        console.error(
          'Registration error:',
          err
        );


        setError(
          t.genericError
        );


        setIsLoading(false);

      }

    };


  // =======================================================
  // RENDER
  // =======================================================

  return (

    <div className="register-page">


      {/* =================================================
          BACKGROUND SLIDESHOW
      ================================================= */}


      <div className="register-bg-overlay"></div>


      <div className="register-digital-grid"></div>


      <div className="register-glow register-glow-one"></div>

      <div className="register-glow register-glow-two"></div>


      {/* =================================================
          MAIN CONTAINER
      ================================================= */}

      <div className="form-container">


        {/* =================================================
            TOP BAR
        ================================================= */}

        <div className="register-topbar">


          <button
            type="button"
            className="register-back"
            onClick={() =>
              navigate('/login')
            }
          >

            <FaArrowLeft />

            <span>
              {t.back}
            </span>

          </button>


          <div className="register-secure-badge">

            <FaShieldAlt />

            <span>
              {t.secure}
            </span>

          </div>

        </div>


        {/* =================================================
            LANGUAGE
        ================================================= */}

        
<div className="language-top">
  <FaGlobe />

  <select
    name="language"
    value={form.language}
    onChange={handleChange}
    aria-label={t.language}
  >
    {LANGUAGES.map((lang) => (
      <option key={lang.code} value={lang.code}>
        {lang.nativeName}
      </option>
    ))}
  </select>
</div>


        {/* =================================================
            LOGO
        ================================================= */}

        <div className="register-logo-section">

          <div className="register-logo-glow">

            <img
              src="/logo512.png"
              alt="Logo"
            />

          </div>

        </div>


        {/* =================================================
            TITLE
        ================================================= */}

        <div className="register-heading">

          <div className="register-heading-icon">

            <FaShieldAlt />

          </div>


          <h1>
            {t.title}
          </h1>


          <p>
            {t.subtitle}
          </p>

        </div>


        {/* =================================================
            ERROR
        ================================================= */}

        {error && (

          <div className="register-alert register-alert-error">

            <span>
              !
            </span>

            <p>
              {error}
            </p>

          </div>

        )}


        {/* =================================================
            SUCCESS
        ================================================= */}

        {success && (

          <div className="register-alert register-alert-success">

            <FaCheckCircle />

            <p>
              {success}
            </p>

          </div>

        )}


        {/* =================================================
            FORM
        ================================================= */}

        <form
          onSubmit={
            handleRegister
          }
          className="register-form"
        >


          {/* =================================================
              FULL NAME
          ================================================= */}

          <div className="register-field">

            <label>
              {t.fullName}
            </label>


            <div className="register-input-wrap">

              <FaUser />


              <input
                type="text"
                name="fullName"
                placeholder={
                  t.fullNamePlaceholder
                }
                value={
                  form.fullName
                }
                onChange={
                  handleChange
                }
                autoComplete="name"
                required
              />

            </div>

          </div>


          {/* =================================================
              USERNAME
          ================================================= */}

          <div className="register-field">

            <label>

              {t.username}

              <small>
                6-16 characters
              </small>

            </label>


            <div className="register-input-wrap">

              <FaUser />


              <input
                type="text"
                name="username"
                placeholder={
                  t.usernamePlaceholder
                }
                value={
                  form.username
                }
                onChange={
                  handleChange
                }
                minLength={6}
                maxLength={16}
                autoComplete="username"
                required
              />

            </div>

          </div>


          {/* =================================================
              EMAIL
          ================================================= */}

          <div className="register-field">

            <label>
              {t.email}
            </label>


            <div className="register-input-wrap">

              <FaEnvelope />


              <input
                type="text"
                name="email"
                placeholder={
                  t.emailPlaceholder
                }
                value={
                  form.email
                }
                onChange={
                  handleChange
                }
                autoComplete="email"
              />

            </div>

          </div>


          {/* =================================================
              PASSWORD
          ================================================= */}

          <div className="register-field">

            <label>
              {t.password}
            </label>


            <div className="register-input-wrap">

              <FaLock />


              <input
                type={
                  showPassword
                    ? 'text'
                    : 'password'
                }
                name="password"
                placeholder={
                  t.passwordPlaceholder
                }
                value={
                  form.password
                }
                onChange={
                  handleChange
                }
                minLength={6}
                maxLength={12}
                autoComplete="new-password"
                required
              />


              <button
                type="button"
                className="password-toggle"
                onClick={() =>
                  setShowPassword(
                    prev => !prev
                  )
                }
                aria-label={
                  showPassword
                    ? t.hide
                    : t.show
                }
              >

                {showPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}

              </button>

            </div>

          </div>


          {/* =================================================
              CONFIRM PASSWORD
          ================================================= */}

          <div className="register-field">

            <label>
              {t.confirmPassword}
            </label>


            <div className="register-input-wrap">

              <FaLock />


              <input
                type={
                  showConfirmPassword
                    ? 'text'
                    : 'password'
                }
                name="confirmPassword"
                placeholder={
                  t.confirmPasswordPlaceholder
                }
                value={
                  form.confirmPassword
                }
                onChange={
                  handleChange
                }
                minLength={6}
                maxLength={12}
                autoComplete="new-password"
                required
              />


              <button
                type="button"
                className="password-toggle"
                onClick={() =>
                  setShowConfirmPassword(
                    prev => !prev
                  )
                }
                aria-label={
                  showConfirmPassword
                    ? t.hide
                    : t.show
                }
              >

                {showConfirmPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}

              </button>

            </div>

          </div>


          {/* =================================================
              COUNTRY
          ================================================= */}

          <div className="register-field">

            <label>
              {t.selectCountry}
            </label>


            <div className="register-input-wrap country-wrap">

              <FaGlobe />


              <select
                className="country-select"
                onChange={
                  handleCountryChange
                }
                value={
                  country
                }
                aria-label={
                  t.selectCountry
                }
              >

                {Object.keys(
                  prefixes
                ).map(c => (

                  <option
                    key={c}
                    value={c}
                  >

                    {c}

                    {prefixes[c]
                      ? ` (${prefixes[c]})`
                      : ''
                    }

                  </option>

                ))}

              </select>

            </div>

          </div>


          {/* =================================================
              PHONE
          ================================================= */}

          <div className="register-field">

            <label>
              {t.phoneNumber}
            </label>


            <div className="phone-input">

              <span className="phone-prefix">

                {prefix || '🌍'}

              </span>


              <div className="phone-divider"></div>


              <FaPhone
                className="phone-icon"
              />


              <input
                type="tel"
                name="phoneNumber"
                placeholder={
                  t.phoneNumber
                }
                value={
                  form.phoneNumber
                }
                onChange={
                  handlePhoneChange
                }
                inputMode="numeric"
                autoComplete="tel"
                required
              />

            </div>

          </div>


          {/* =================================================
              REFERRAL
          ================================================= */}

          <div className="register-field">

            <label>
              {t.referralCode}
            </label>


            <div className="register-input-wrap">

              <FaGift />


              <input
                type="text"
                name="referralInput"
                placeholder={
                  t.referralPlaceholder
                }
                value={
                  form.referralInput
                }
                onChange={
                  handleChange
                }
              />

            </div>

          </div>


          {/* =================================================
              SUBMIT
          ================================================= */}

          <button
            type="submit"
            className="register-submit"
            disabled={
              isLoading
            }
          >

            {isLoading ? (

              <>

                <span className="register-spinner"></span>

                <span>
                  {t.processing}
                </span>

              </>

            ) : (

              <>

                <FaShieldAlt />

                <span>
                  {t.register}
                </span>

              </>

            )}

          </button>


        </form>


        {/* =================================================
            SUCCESS BOTTOM
        ================================================= */}

        {success && (

          <div className="register-success-bottom">

            <FaCheckCircle />

            <span>
              {success}
            </span>

          </div>

        )}


        {/* =================================================
            CUSTOMER CARE / CONTACT US
        ================================================= */}

        <div className="register-customer-care">

          <div className="register-customer-icon">

            <FaHeadset />

          </div>


          <div className="register-customer-text">

            <span className="register-customer-label">

              {t.needHelp}

            </span>


            <strong>

              {t.contactUs}

            </strong>


            <small>

              {t.customerCareText}

            </small>

          </div>


          <Link
            to="/customer-cares"
            className="register-customer-button"
          >

            {t.contact}

            <span>
              →
            </span>

          </Link>

        </div>


        {/* =================================================
            LOGIN
        ================================================= */}

        <div className="register-login">

          <span>
            {t.alreadyHaveAccount}
          </span>


          <Link to="/login">

            {t.loginHere}

          </Link>

        </div>


        {/* =================================================
            FOOTER
        ================================================= */}

        <div className="register-footer">

          <span>

            <FaShieldAlt />

            SECURE

          </span>


          <i></i>


          <span>

            <FaLock />

            PROTECTED

          </span>


          <i></i>


          <span>

            <FaCheckCircle />

            DIGITAL

          </span>

        </div>


      </div>

    </div>

  );

};


export default Register;